import {
  CheckCircleOutlined,
  CheckCircleTwoTone,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

interface StatusTagProps {
  status: string;
}

const statusMap: Record<
  string,
  { icon: React.ReactNode; color: string; label: string }
> = {
  active: {
    icon: <CheckCircleOutlined />,
    color: 'success',
    label: 'Ativo',
  },
  inactive: {
    icon: <MinusCircleOutlined />,
    color: 'default',
    label: 'Inativo',
  },
  unpublished: {
    icon: <ExclamationCircleOutlined />,
    color: 'warning',
    label: 'Não publicado',
  },
  incompleted: {
    icon: <ExclamationCircleOutlined />,
    color: 'error',
    label: 'Incompleto',
  },
  completed: {
    icon: <CheckCircleTwoTone twoToneColor='#52c41a' />,
    color: 'default',
    label: 'Completo',
  },
  scheduled: {
    icon: <ClockCircleOutlined />,
    color: 'processing',
    label: 'Programado',
  },
};

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const { icon, color, label } = statusMap[status] || {
    icon: null,
    color: 'default',
    label: status,
  };

  return (
    <Tag icon={icon} color={color}>
      {label}
    </Tag>
  );
};
